import {
  Heading,
  Highlight,
  Box,
  type BoxProps,
  type HeadingProps,
  type SystemStyleObject,
} from "@chakra-ui/react";
import React from "react";

interface WithHeading1Props {
  children: React.ReactNode;
  query?: string[];
  styles?: SystemStyleObject;
  size?: HeadingProps["size"];
  pt?: BoxProps["pt"];
  textAlign?: BoxProps["textAlign"];
  fontWeight?: HeadingProps["fontWeight"];
  lineHeight?: HeadingProps["lineHeight"];
}

export default function WithHeading1({
  children,
  query = [],
  styles = {
    px: "0.5",
  },
  size = { base: "2xl", md: "3xl", xl: "4xl" },
  pt = { base: "4", md: "8" },
  textAlign = { base: "center", md: "left" },
  fontWeight = "black",
  lineHeight = "tall",
}: WithHeading1Props) {
  return (
    <Box pt={pt} textAlign={textAlign}>
      <Heading
        //
        as="h1"
        size={size}
        mb="2"
        fontWeight={fontWeight}
        lineHeight={lineHeight}
      >
        {query.length > 0 ? (
          <Highlight query={query} styles={styles}>
            {String(children)}
          </Highlight>
        ) : (
          children
        )}
      </Heading>
    </Box>
  );
}
